import { useState } from 'react';
import { Ellipsis } from 'lucide-react';
import { cn } from '@/utils/utils.ts';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Skeleton } from '@/components/ui/skeleton.tsx';
import { SmartMeterReportDialog } from './smart-meter-report-dialog.tsx';

type SmartMeterMenuPopoverProps = {
  deviceId: string;
  deviceName?: string;
  isLoading?: boolean;
};

export function SmartMeterMenuPopover({
  deviceId,
  deviceName,
  isLoading,
}: SmartMeterMenuPopoverProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (isLoading) {
    return <Skeleton className="h-9 w-12" />;
  }

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-[48px] border-2 border-gray-300 p-2">
          <Ellipsis />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={cn(
          'relative mr-4 w-55 overflow-hidden rounded-lg border bg-white/95 p-1 shadow-xl backdrop-blur-xl dark:bg-gray-900/95'
        )}
      >
        <div>
          <SmartMeterReportDialog deviceId={deviceId} deviceName={deviceName} />
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default SmartMeterMenuPopover;
